module.exports = __webpack_public_path__ + "img/Group_10680.e3feed45.svg";